<template>
  <div class="checkout-coupon panel p-4 mb-4">
    <transition name="fade">
      <Alert v-if="hasAlert" :alert="alert" />
    </transition>
    <div v-if="!!coupon" class="alert alert-success text-center">
      Your coupon has been applied
    </div>
    <h3 class="text-center text-primary font-weight-bold">{{ heading }}</h3>
    <p v-html="instructions"></p>
    <div class="row no-gutters">
      <div class="col">
        <Field
          type="text"
          name="coupon_code"
          v-model="couponCode"
          :readonly="!!coupon"
        />
      </div>
      <div
        class="col text-right"
        :style="`max-width:` + (!!coupon ? `6.5rem` : `6rem`)"
      >
        <a
          v-if="!!coupon"
          class="btn btn-danger"
          href="#"
          @click.prevent="remove()"
          >Remove</a
        >
        <a v-else class="btn btn-primary" href="#" @click.prevent="apply()"
          >Apply</a
        >
      </div>
    </div>
  </div>
</template>

<script>
import DisplaysAlerts from "mixins/DisplaysAlerts";
export default {
  mixins: [DisplaysAlerts],
  props: {
    coupon: { type: Object, default: () => {} },
  },
  data() {
    return {
      couponCode: null,
    };
  },
  computed: {
    heading() {
      return !!this.coupon ? "Your Coupon" : "Have a coupon code?";
    },
    instructions() {
      return !!this.coupon
        ? "To remove it, click <strong>Remove</strong>."
        : "Enter it in the field below and then click <strong>Apply</strong>.";
    },
  },
  watch: {
    coupon(val) {
      this.couponCode = !!this.coupon ? this.coupon.code : null;
    },
  },
  methods: {
    apply() {
      this.hideAlert();
      if (!this.couponCode) {
        alert(
          `Please enter a coupon code in the field provided and then click "Apply"`
        );
        return;
      }
      this.axios
        .post(this.route("enroll.online.coupon.apply"), {
          code: this.couponCode,
        })
        .then((response) => {
          var coupon = response.data.coupon;
          var subtotal = response.data.subtotal;
          var discount = response.data.discount;
          var total = response.data.total;
          this.$emit("apply", coupon, subtotal, discount, total);
        })
        .catch((error) => {
          this.showAlert("danger", "Invalid coupon code provided");
        });
    },
    remove() {
      this.axios.post(this.route("enroll.online.coupon.remove")).then(() => {
        this.$emit("remove");
      });
    },
  },
  created() {
    this.couponCode = !!this.coupon ? this.coupon.code : null;
  },
};
</script>